export const CX_ARTICLE = 'CX_ARTICLE'
export const CX_COMPONENT = 'CX_COMPONENT'
export const CX_CONSENT = 'CX_CONSENT'
export const CX_ERROR = 'CX_ERROR'
export const CX_ORDER = 'CX_ORDER'
export const CX_PAGE = 'CX_PAGE'
export const CX_PLATFORM = 'CX_PLATFORM'
export const CX_PRODUCER = 'CX_PRODUCER'
export const CX_NAVIGATION = 'CX_NAVIGATION'
export const CX_USER = 'CX_USER'
export const SP_CONTACT_REASON = 'SP_CONTACT_REASON'
